module.exports = __webpack_public_path__ + "static/media/s1.1192a86d.jpg";